module.exports = __webpack_public_path__ + "img/stage5.e8d09eda.svg";